import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { normalizeLanguageCode } from "utils/apiLanguage";
import { getLocaleFromPathname } from "utils/localePath";

const syncDocumentLanguage = (lng) => {
  document.documentElement.lang = normalizeLanguageCode(lng) || "es";
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: "urlPath",
  lookup() {
    if (typeof window === "undefined") return undefined;
    return getLocaleFromPathname(window.location.pathname);
  },
  cacheUserLanguage(lng) {
    localStorage.setItem("i18nextLng", lng);
  },
});

i18n.use(Backend).use(languageDetector).use(initReactI18next).init({
  fallbackLng: "es",
  load: "currentOnly",
  backend: {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
  },
  detection: {
    order: ["urlPath", "localStorage"],
    caches: ["localStorage"],
  },
  react: {
    useSuspense: false,
  },
});

syncDocumentLanguage(i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);